const political = [
  '团员',
  '党员',
  '预备党员',
  '群众',
]
const marital = [
  '未婚', '已婚', '离异'
]
const edu = [
  '本科', '研究生', '博士'
]
const sex = [
  '男',
  '女'
]
const convertBase64UrlToBlob = function (urlData) {
  let bytes = window.atob(urlData.split(",")[1]); //'去掉url的头',并转换为byte
  //处理异常,将ascii码小于0的转换为大于0
  let ab = new ArrayBuffer(bytes.length);
  let ia = new Uint8Array(ab);
  for (var i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
  }
  return new Blob([ab], {
    type: "image/png",
  });
};
const specific = [
  '普通话',
  '英语专业八级',
  '雅思',
  '托福'
]
const cardType = [
  '国内身份证',
  '香港身份证',
  '澳门身份证'
]

export {
  political,
  marital,
  edu,
  sex,
  convertBase64UrlToBlob,
  specific,
  cardType,
}